import React from "react";
import ReactDOM from "react-dom/client";

import "tippy.js/dist/tippy.css";
import "./index.css";
import "styles/global.scss";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
reportWebVitals();
